export const TOUR_BUTTON_CLASSES = {
  primary: "tour-btn tour-btn-primary",
  secondary: "tour-btn tour-btn-secondary",
  ghost: "tour-btn tour-btn-ghost",
};

export const TOUR_TOOLTIP_CLASSES = {
  base: "tour-tooltip",
};

export const DEFAULT_TOUR_TOOLTIP_WIDTH_PX = 280;
export const DEFAULT_TOUR_TOOLTIP_MAX_WIDTH_PX = 320;

export function resolveTourStepWidth(
  width: string | number,
): { width: string; maxWidth: string } {
  const value = typeof width === "number" ? `${width}px` : width;
  return { width: value, maxWidth: value };
}
